import React, { memo, useMemo, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Pages from "..";
import { BtnPlaceYourOrder } from "./Cart.style";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux";
import { CartType } from "../../gobalType";

import { BASE_URL, HttpMethod } from "../../services/api.constant";
import { callHttpClientMethod } from "../../services/callHttpClient";
import { countReadUnNoti, orderCart } from "../../services/apiList";
import BasicModal from "./components/Modal";
import LoadingCart from "./components/Loading";
import "./style.scss";
import { useNavigate } from "react-router-dom";
import BestSallersCart from "./components/BestSallers";
import { toast } from "react-toastify";
import { TypesAction } from "../../redux/typesAction";
import DefaultText from "../../components/Text/DefaultText";
import TitleText from "../../components/Text/TitleText";
import ModalConfirm from "./components/ModalConfirm";
import CartTable from "./components/CartTable";
import AdditionalListSection from "./components/AdditionalListSection";
import { useAdditionalList } from "./hooks/useAdditionalList";
import { useDesiredDeliveryDate } from "./hooks/useDesiredDeliveryDate";

const displayRes = {
  xs: "none",
  sm: "flex",
};

const Cart = () => {
  const dispatch = useDispatch();
  const { carts } = useSelector((state: RootState) => state.cart);

  const navigate = useNavigate();
  const { user, auth } = useSelector((state: RootState) => state.auth);
  const additional = useAdditionalList();
  const deliveryDate = useDesiredDeliveryDate();
  const [showOrder, setShowOrder] = useState(false);
  const [orderCode, setOrderCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [changeQTY, setChangeQTY] = useState(false);
  const [indexDel, setIndexDel] = useState<any>(null);
  const [openConfirm, setOpenConfirm] = useState<boolean>(false);

  const totalPrice = useMemo(() => {
    let result = 0;
    carts?.map((item: CartType) => {
      return (result += Number(item.price) * Number(item.quantity));
    });
    return result;
  }, [carts]);

  const isPcsCart = useMemo(
    () => carts.length > 0 && carts[0]?.isCategory === "pcs",
    [carts],
  );

  const handleOrder = async () => {
    setLoading(true);
    if (isPcsCart && !deliveryDate.isValid) {
      toast.error(
        `Desired Delivery Date must be in ${deliveryDate.DATE_FORMAT_UI} format`,
      );
      setLoading(false);
      return;
    }
    const payload = {
      delivery_address: user.address,
      phone_number: user.phone_number,
      person_name: user.name,
      email: user.email,
      desired_delivery_date: isPcsCart ? deliveryDate.apiValue : undefined,
      note: isPcsCart ? additional.notePayload : [],
      company_name: user.company_name,

      products: carts?.map((item) => {
        return {
          product_id: item.id,
          size_id: item.size_id,
          total: Number(item.quantity),
          price: item.price ? item.price : 0,
          category_id: item.isCategory === "pcs" ? 1 : 2,
        };
      }),
    };

    if (payload.delivery_address == null || payload.phone_number == null) {
      toast.error("Please update delivery address and phone number in your account");
      navigate("/account");
      setLoading(false);
      return;
    }
    try {
      const response = await callHttpClientMethod(
        BASE_URL + orderCart(),
        HttpMethod.Post,
        payload,
        {
          headers: {
            Authorization: `Bearer ${auth.access_token}`,
          },
        },
      );
      if (response?.status_code == 200) {
        setOrderCode(response?.data?.order_code);
        setShowOrder(true);
        additional.reset();
        deliveryDate.reset();
        dispatch({ type: TypesAction.RESET_CART });
        handleCountUnRead();
      } else {
        toast.error(
          response?.message || "Unable to place order. Please try again.",
        );
      }
    } catch (error: any) {
      toast.error(error?.message);
    } finally {
      setLoading(false);
    }
  };
  const handleCountUnRead = async () => {
    try {
      const respon = await callHttpClientMethod(
        BASE_URL + countReadUnNoti(),
        HttpMethod.Get,
        {},
        {
          headers: {
            Authorization: `Bearer ${auth?.access_token}`,
          },
        },
      );
      if (respon?.status_code == 200) {
        dispatch({ type: TypesAction?.COUNT_NOTI, payload: respon?.data });
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  const gotoDetail = (item: any) => {
    navigate(`/product-details/${item.id}`, {
      state: {
        product_id: item?.product_id,
        size_id: item?.size_id,
      },
    });
  };

  const DelPro = () => {
    dispatch({
      type: TypesAction.REMOVE_PRODUCT,
      payload: indexDel,
    });
    setIndexDel(null);
    setOpenConfirm(false);
    toast.warn("Product has been deleted");
  };

  return (
    <Pages seo={{ title: "TBT Groups", description: "TBT Groups" }}>
      <Box
        sx={{
          backgroundColor: "#fff",
          px: { xs: "12px", sm: 0 },
        }}
        className="bg_box"
      >
        <Box
          textAlign="center"
          sx={{
            display: displayRes,
            justifyContent: "center",
            marginBottom: "20px",
          }}
        >
          <Typography
            variant="h2"
            sx={{
              textTransform: "uppercase",
              fontSize: "25px",
              color: "#50555c",
            }}
          >
            Your cart
          </Typography>
        </Box>
        <LoadingCart isOpen={loading} />
        <BasicModal
          isOpen={showOrder}
          handleClose={() => setShowOrder(false)}
          title={"Thanks for your placed order"}
          content={
            <>
              Your Order confirmation{" "}
              <Box
                component="span"
                sx={{ fontWeight: 800, color: "#0d0d0d" }}>
                No.{orderCode || ""}
              </Box>{" "}
              will be sent to your email.
            </>
          }
        />
        <ModalConfirm
          isOpen={openConfirm}
          handleClose={() => setOpenConfirm(false)}
          title={"Confirm"}
          content={`You definitely want to delete product ${carts[indexDel]?.name}?`}
          handleClear={DelPro}
        />
        {carts.length === 0 ? (
          <Box
            sx={{
              height: { sm: "400px", xs: "200px" },
              alignItems: "center",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <DefaultText>The shopping cart is empty!</DefaultText>
          </Box>
        ) : (
          <>
            <CartTable
              isPcsCart={isPcsCart}
              carts={carts}
              displayRes={displayRes}
              totalPrice={totalPrice}
              onGoToDetail={gotoDetail}
              onEditQuantity={(index, quantity) => {
                setChangeQTY(!changeQTY);
                dispatch({
                  type: TypesAction.EDIT_QUANTITY,
                  payload: { quantity, index },
                });
              }}
              onRequestDelete={(index) => {
                setIndexDel(index);
                setOpenConfirm(true);
              }}
            />
          </>
        )}

        <Box sx={{ px: { xs: 0, sm: "15px" } }}>
          {carts.length !== 0 && (
            <Box>
              {isPcsCart && (
                <AdditionalListSection
                  sizeOptions={additional.SIZE_OPTIONS}
                  rows={additional.rows}
                  canDelete={additional.canDelete}
                  onAddRow={additional.addRow}
                  onUpdateRow={additional.updateRow}
                  onRemoveRow={additional.removeRow}
                  desiredDeliveryDateValue={deliveryDate.uiValue}
                  onDesiredDeliveryDateChange={deliveryDate.setUiValue}
                />
              )}

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              ></Box>
              <Box
                textAlign={"center"}
                mt={"20px"}
                mb={"60px"}
              >
                <BtnPlaceYourOrder className="btn_order" onClick={handleOrder}>
                  <DefaultText>Place Your Order</DefaultText>
                </BtnPlaceYourOrder>
              </Box>
            </Box>
          )}
          <TitleText style={{ fontWeight: "700", marginTop: "20px" }}>
            BEST SELLER{" "}
          </TitleText>
          <BestSallersCart changeQTY={() => setChangeQTY(!changeQTY)} />
        </Box>
      </Box>
    </Pages>
  );
};

export default memo(Cart);
